import LeadsPageContainer from './LeadsPageContainer';

export default LeadsPageContainer;
